import { all, call } from "redux-saga/effects"

import { categoriesSaga } from "./categories/categories.saga"
import { userSagas } from "./user/user.saga"
import { cartSaga } from "./cart/cart.saga"

export function* rootSaga() {
    yield all([
        call(categoriesSaga),
        call(userSagas),
        call(cartSaga)
    ])
}